declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '846969475009809'
const CHECKOUT_URL = 'https://pay.hotmart.com/X104929887V?checkoutMode=10'

export function initMetaPixel(): void {
  if (window.fbq) return

  const f: any = (window.fbq = function (...args: any[]) {
    f.callMethod ? f.callMethod(...args) : f.queue.push(args)
  })

  if (!window._fbq) window._fbq = f
  f.push = f
  f.loaded = true
  f.version = '2.0'
  f.queue = []

  // Inject the fbevents.js script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Initialize pixel
  window.fbq('init', PIXEL_ID)

  // Fire PageView
  window.fbq('track', 'PageView')

  // Fire ViewContent
  window.fbq('track', 'ViewContent', {
    content_name: 'The Urban Autonomy System',
    content_type: 'product',
    value: 9.99,
    currency: 'USD',
  })

  // Also inject noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

export function trackAddToCartAndRedirect(
  e: React.MouseEvent<HTMLAnchorElement>,
): void {
  e.preventDefault()

  // Fire AddToCart event
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'The Urban Autonomy System',
      content_type: 'product',
      value: 9.99,
      currency: 'USD',
    })
  }

  // Delay 350ms to ensure the pixel fires, then redirect
  setTimeout(() => {
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
  }, 350)
}
